import m from './module';
import LogicGroup from '../model/LogicGroup';

class LogicGroupService {
  constructor($q, LogicConditionService, LogicModifierService, LogicFilterService, LocationFilterService) {
    "ngInject";
    this.$q = $q;
    this.LogicConditionService = LogicConditionService;
    this.LogicModifierService = LogicModifierService;
    this.LogicFilterService = LogicFilterService;
    this.LocationFilterService = LocationFilterService;
  }

  create(data) {
    data = data || {};

    const conditions = data.conditions || [];
    const populatedConditions = [];
    const conditionPromises = conditions.map(condition =>
      this.$q.when(this.LogicConditionService.create(condition))
        .then(populatedCondition => {
          populatedConditions.push(populatedCondition);
        })
    );

    const modifiers = data.modifiers || [];
    const populatedModifiers = [];
    const modifierPromises = modifiers.map(modifier =>
      this.$q.when(this.LogicModifierService.create(modifier))
        .then(populatedModifier => {
          populatedModifiers.push(populatedModifier);
        })
    );

    const logicFilters = data.logic_filters || [];
    const populatedLogicFilters = [];
    const logicFilterPromises = logicFilters.map(logicFilter =>
      this.$q.when(this.LogicFilterService.create(logicFilter))
        .then(populatedLogicFilter => {
          populatedLogicFilters.push(populatedLogicFilter);
        })
    );

    const locationFilters = data.filters || [];
    const populatedLocationFilters = [];
    const locationFilterPromises = locationFilters.map(locationFilter =>
      this.$q.when(this.LocationFilterService.create(locationFilter))
        .then(populatedLocationFilter => {
          populatedLocationFilters.push(populatedLocationFilter);
        })
    );

    return this.$q.all([
      ...conditionPromises,
      ...modifierPromises,
      ...logicFilterPromises,
      ...locationFilterPromises,
    ])
      .then(() => {
        data.conditions = populatedConditions;
        data.modifiers = populatedModifiers;
        data.logic_filters = populatedLogicFilters;
        data.filters = populatedLocationFilters;
        return new LogicGroup(data)
      });
  }

  serialize(logicGroup) {
    return {
      id: logicGroup.id,
      conditions: logicGroup.conditions.map(condition => this.LogicConditionService.serialize(condition)),
      modifiers: logicGroup.modifiers.map(modifier => this.LogicModifierService.serialize(modifier)),
      logic_filters: logicGroup.logic_filters.map(logic_filter => this.LogicFilterService.serialize(logic_filter)),
      filters: logicGroup.filters.map(filter => this.LocationFilterService.serialize(filter)),
    };
  }
}

export default LogicGroupService;

m.service('LogicGroupService', LogicGroupService);
